module.exports = __webpack_public_path__ + "Bliss2-Medium.2b40d50c278bf8484d2a.woff";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/Bliss2-Medium.woff
// module id = ../../../../../src/assets/layout/fonts/Bliss2-Medium.woff
// module chunks = styles